import React, { createContext, useEffect, useContext } from 'react'

const FooterContext = createContext()
const useFooterContext = () => useContext(FooterContext)

const FooterConsumer = FooterContext.Consumer

const FooterProvider = ({ children, ...rest }) => {
  const state = { ...rest }

  return (
    <FooterContext.Provider value={state}>{children}</FooterContext.Provider>
  )
}

export { FooterConsumer, FooterProvider, useFooterContext }
